import { render, staticRenderFns } from "./PreviewNCF.vue?vue&type=template&id=06994ea0&scoped=true&"
import script from "./PreviewNCF.vue?vue&type=script&lang=js&"
export * from "./PreviewNCF.vue?vue&type=script&lang=js&"
import style0 from "./PreviewNCF.vue?vue&type=style&index=0&id=06994ea0&prod&lang=scss&scoped=true&"
import style1 from "./PreviewNCF.vue?vue&type=style&index=1&id=06994ea0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06994ea0",
  null
  
)

export default component.exports